<template>
  <NuxtLayout
    name="generic"
    header="standardDark"
    footer="standard"
  >
    <div
      :class="{
        'blog-template mt-70px bg-www-color-neutral-off-white md:mt-120px': true,
        'max-md:[&>p.content]:text-sm': true,
      }"
    >
      <template v-if="data">
        <BreadCrumbFromRoute
          :class="{
            'hero-container': true,
          }"
          :title="data.title"
        />

        <BlogHero :blog-hero="data.blogHero" />

        <PortableText
          v-if="data.content.blogPortableText"
          :class="{
            'p-0 text-www-color-neutral-medium-dark': true,
          }"
          :portable-data="data?.content.blogPortableText"
        />

        <CTABanner
          v-if="data.CTABanner?.reference"
          :data="data.CTABanner.reference"
        />

        <SuggestedContent
          v-if="!data.removeSuggestedContent"
          :suggested-title="data.suggestedContentTitle"
        />
      </template>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryWhatIsNew } from '~/queries/pages/PageWhatIsNew.query';
import type { QueryWhatIsNewResult } from '~/sanity/types';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQuery<QueryWhatIsNewResult>(queryWhatIsNew, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  author: data.value?.blogHero.person?.reference?.name,
  description: data.value?.ogDescription || data.value?.description,
  ogImage: data.value?.ogImage ?? data.value?.heroImage,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  title: data.value?.htmlTitle || data.value?.title,
});
</script>
